<template src="./component.html"></template>

<script>
export default {
  name: "Module"
}
</script>

<style src="./component.scss" scoped lang="scss"/>
